import * as React from 'react';
import { Link } from '@grandvisionhq/common';
import { Container } from '@grandvisionhq/elements';
import LazyPicture from '../LazyPicture/LazyPicture.js';
import Picture from '../Picture/Picture.js';

const Banner = ({ image , mobileImage , link , useContainer =false , useLazyLoading =true ,  })=>{
    const ContainerComponent = useContainer ? Container : React.Fragment;
    let imgSizes;
    if (useContainer) {
        // banner width is capped at 1370px when in a container
        imgSizes = {
            M: 768,
            L: 1024,
            XL: 1370,
            MAX: 1370
        };
    }
    if (!image) {
        console.warn('Cannot render Banner: missing image');
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "banner"
    }, /*#__PURE__*/ React.createElement(ContainerComponent, null, useLazyLoading ? /*#__PURE__*/ React.createElement(LazyPicture, {
        mobileImage: mobileImage,
        image: image,
        imgSizes: imgSizes
    }) : /*#__PURE__*/ React.createElement(Picture, {
        mobileUrl: mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.url,
        url: image.url,
        alt: image.alt,
        width: image.dimensions.w,
        height: image.dimensions.h,
        imgSizes: imgSizes
    }), link && /*#__PURE__*/ React.createElement(Link, {
        hidden: true,
        url: link.url,
        target: link.target,
        className: "banner__link"
    }, link.label && /*#__PURE__*/ React.createElement("span", {
        className: "banner__link-text"
    }, link.label))));
};
var Banner$1 = Banner;

export { Banner$1 as default };
//# sourceMappingURL=Banner.js.map
